import React, { type PropsWithChildren, type MouseEvent } from "react";
import { createPortal } from "react-dom";
import { twMerge } from "tailwind-merge";

import { usePortalRoot } from "../../../hooks/usePortalRoot";

export interface BackdropProps extends PropsWithChildren {
  className?: string;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
  open?: boolean;
  portal?: boolean;
}

export function SupBackdrop({ open = false, portal = false, children, className, onClick }: BackdropProps) {
  const root = usePortalRoot(portal);
  const content = open ? (
    <div className={twMerge("sup-backdrop flex justify-center items-center fixed inset-0 bg-neutral-200/44 z-40 backdrop-blur-sm", className)} onClick={onClick}>
      {children}
    </div>
  ) : null;

  return portal && root ? createPortal(content, root) : content;
}
